import { render, staticRenderFns } from "./AuthContainer.vue?vue&type=template&id=b9c2a7f4&"
var script = {}
import style0 from "./AuthContainer.vue?vue&type=style&index=0&id=b9c2a7f4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports